// client/src/hooks/useAnalytics.js

import { useState, useCallback } from 'react';
import analyticsService from '../services/analyticsService';

const useAnalytics = () => {
  const [summary, setSummary] = useState(null);
  const [categoryBreakdown, setCategoryBreakdown] = useState(null);
  const [monthly, setMonthly] = useState({ granularity: 'month', points: [] });
  const [budgets, setBudgets] = useState([]);
  const [subscriptions, setSubscriptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const load = useCallback(async ({ from, to, accountId } = {}) => {
    setLoading(true);
    setError('');
    try {
      const [summaryData, categoriesData, monthlyData, budgetData, subsData] = await Promise.all([
        analyticsService.getSummary({ from, to, accountId }),
        analyticsService.getCategories({ from, to, accountId }),
        // Calé sur la période choisie ; sans période (« tout »), months=0 = tout l'historique.
        analyticsService.getMonthly({ months: 0, from, to, accountId }),
        analyticsService.getBudgets({ accountId }),
        analyticsService.getSubscriptions({ accountId })
      ]);
      setSummary(summaryData);
      setCategoryBreakdown(categoriesData);
      setMonthly(monthlyData);
      setBudgets(budgetData);
      setSubscriptions(subsData);
    } catch (err) {
      setError(err.message || "Impossible de charger l'analyse des dépenses.");
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return { summary, categoryBreakdown, monthly, budgets, subscriptions, loading, error, load };
};

export default useAnalytics;
